import LanguageCC from 'components/Layout/LanguageCC';
import { PATH_ROOT, URL_LANDING_PAGE } from 'constants/api';
import { AppInfo, FooterAuthentication } from 'layouts';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import RegisterSSOSameEmail from '../components/RegisterSSOSameEmail';
import './index.css';
import ConflictCustomerCode from '../components/ConflictCustomerCode';
import RegisterSSONoEmail from '../components/RegisterSSONoEmail';
import { useAuthFlow } from '../AuthFlowContext';

export default function VerifySSO() {
    const { sso } = useAuthFlow();
    const SSOInfo = sso.info;
    const detail = SSOInfo?.detail;
    const params = useParams()
    const provider = params.provider
    const navigate = useNavigate();

    useEffect(() => {
        if (!SSOInfo) {
            navigate(`${PATH_ROOT}/auth/register`, { replace: true });
        }
    }, [SSOInfo, navigate]);

    if (!SSOInfo) {
        return null;
    }

    return (
        <div className="register-email-container">
            <div className='drop-down-language'>
                <LanguageCC />
            </div>
            <div style={{ position: "relative", width: '100%', cursor: 'pointer' }} onClick={() => window.open(URL_LANDING_PAGE)}>
                <img alt='logo-register' style={{ position: 'absolute', marginBottom: '0px' }} className="logo-register-img" src={require('../../../assets/img/logo_020823.svg').default}></img>
            </div>
            <div style={{ width: '100%' }}>
                <div className="register-email-body">
                    <div className="register-email-image">
                        <div className="register-email-body-left">
                            <AppInfo />
                            {
                                detail === "NEW"
                                    ?
                                    <img
                                        alt='left-content'
                                        className=""
                                        width="90%"
                                        src={require('../../../assets/img/left_content_1.svg').default}
                                    ></img>
                                    :
                                    <img
                                        alt='link-account'
                                        className=""
                                        width="90%"
                                        src={require('../../../assets/img/link_account.svg').default}
                                    ></img>
                            }
                        </div>
                    </div>
                    <div className="register-email-dialog">
                        <div className="form-register-container">
                            <div className="form-register-body">
                                {detail === "NEW" && <RegisterSSONoEmail SSOInfo={SSOInfo} provider={provider} />}
                                {detail === "MAIL_EXIST" && <RegisterSSOSameEmail SSOInfo={SSOInfo} provider={provider} />}
                                {detail === "DIFFERENT_CUSTOMER" && <ConflictCustomerCode SSOInfo={SSOInfo} provider={provider} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterAuthentication />
        </div>
    );
}
